// TableHeader.jsx
import React, { Children } from 'react';
import { FaArrowDown, FaArrowUp } from 'react-icons/fa';
import { svgIcons } from '../../../style/fonts/SvgIcons';

const TableHeading = ({ className, label, sortedColumn, sortOrder, handleSort, children, columnId, labelClassName }: any) => {
    return (
        <th className={className} onClick={() => handleSort(columnId)}
        // style={{borderRadius:0}}
        >
            <div className={`${labelClassName} cursor-pointer table-arrow d-flex gap-3 align-items-center w-100`}>
                {label}
                {sortedColumn === columnId && (
                    <>
                        {sortOrder === 'desc' ? svgIcons.SortArrows : svgIcons.SortArrows}
                    </>
                )}
            </div>
            {children}
        </th>
    );
};

export default TableHeading;
